import React from 'react';
import styled from 'styled-components';

const StyledFeatureCard = styled.div`
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(81, 194, 201, 0.2);
  border-radius: 16px;
  padding: 40px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  
  &:hover {
    transform: translateY(-8px);
    border-color: rgba(81, 194, 201, 0.5);
    box-shadow: 0 20px 40px rgba(81, 194, 201, 0.2);
  }
  
  .feature-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #51c2c9 0%, #2eb8bf 100%);
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    position: relative;
    box-shadow: 0 8px 20px rgba(81, 194, 201, 0.4);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    
    &::before {
      content: '';
      position: absolute;
      inset: -3px;
      background: linear-gradient(135deg, #51c2c9 0%, #2eb8bf 100%);
      border-radius: 23px;
      opacity: 0.2;
      filter: blur(12px);
      z-index: -1;
      transition: all 0.4s ease;
    }
    
    svg {
      transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }
  
  &:hover .feature-icon {
    transform: translateY(-4px);
    box-shadow: 0 16px 32px rgba(81, 194, 201, 0.6);
    
    &::before {
      opacity: 0.4;
      filter: blur(16px);
    }
    
    svg {
      transform: scale(1.1);
    }
  }
  
  h4 {
    font-size: 1.5rem;
    color: #ffffff;
    margin-bottom: 16px;
    font-weight: 600;
  }
  
  p {
    color: #94a3b8;
    line-height: 1.6;
    margin: 0;
  }
`;

interface FeatureCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ icon, title, description }) => {
  return (
    <StyledFeatureCard>
      <div className="feature-icon">
        {icon}
      </div>
      <h4>{title}</h4>
      <p>{description}</p>
    </StyledFeatureCard>
  );
};

export default FeatureCard;

